import { useEffect } from "react";
import LicencesDashboard from "../components/LicencesDashboard";
import { useAppContext } from "../hooks/useAppContext";
import { useLazyGetLicences } from "../operations/queries/getLicences";

const LicencesDashboardContainer = () => {
  const { currentOrganization } = useAppContext();
  const { getLicences, data: licences, status: getLicencesStatus } = useLazyGetLicences();

  useEffect(() => {
    if (currentOrganization) {
      getLicences({
        variables: {
          orgId: currentOrganization.id,
          isArchived: null,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization]);

  return (
    <LicencesDashboard
      licences={licences && licences.licences?.items}
      isLoading={getLicencesStatus.loading}
    />
  );
};

export default LicencesDashboardContainer;
